module.exports = __webpack_public_path__ + "static/media/log.50d47762.png";